import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-brand-logo',
  standalone: true,
  template: `<span class="brand-logo-mask" aria-hidden="true"></span>`,
  styles: [`
    .brand-logo-mask {
      display: block;
      width: 100%;
      height: 100%;
      background: currentColor;
      -webkit-mask: url('/assets/brand/canitrack-mark-v2.png') center / contain no-repeat;
      mask: url('/assets/brand/canitrack-mark-v2.png') center / contain no-repeat;
    }
  `],
  host: {
    class: 'block',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandLogoComponent {}
